<div class="relative-container">
  <a id="alerts" class="alerts" (click)="toggleMenu(true)" #toggleButton [matMenuTriggerFor]="appMenu2">
    <div class="bkg">
      <mat-icon> {{ hasAlerts ? 'notification_important' : 'notifications' }}</mat-icon>
      <span *ngIf="newAlerts && hasAlerts" class="badge"></span>
      <!-- <span>alerts</span> -->
    </div>
  </a>
  <mat-menu #appMenu2="matMenu">
    <ul class="list-style" id="alerts-list">
      <ng-container *ngIf="alertList.length > 0">
        <div *ngFor="let alert of alertList; let i = index">
          <li>
            {{ alert['message'] | anessaTranslation: trigger: alert['params'] }}
          </li>
          <hr *ngIf="i+1 < alertList.length">
        </div>
      </ng-container>
      <li *ngIf="alertList.length === 0">
        <span>{{'DROPDOWN.NO_ALERTS' | anessaTranslation: trigger}}</span>
      </li>
    </ul>
  </mat-menu>
</div>
